<template>
  <div id="app" >
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    const StateCheck = localStorage.getItem('State-Check')
    if (StateCheck === '1') {
      localStorage.removeItem('State-Check')
      console.log(StateCheck)
      window.location.href = '/adminleftlist'
    }
    if (StateCheck === '2') {
      localStorage.removeItem('State-Check')
      console.log(StateCheck)
      window.location.href = '/enterpriselist'
    }
    if (StateCheck === '3') {
      localStorage.removeItem('State-Check')
      console.log(StateCheck)
      window.location.href = '/disclosureshome'
    }
    // const ent = localStorage.getItem('User-Auth')
    // if (admin === null && ent === null) {
    //   console.log(that.$route.path)
    //   if (that.$route.path !== '/') {
    //     window.location.href = '/'
    //   }
    // }
  }
}
</script>

<style>
body {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue